import React from 'react';
import ChapterCard from '../ChapterCard';
import { PlaybookHomeLayout } from '../styles';
import { Link } from 'gatsby';

const Chapters = ({ splashPageSlug, chapters, progress }) => {
  return (
    <PlaybookHomeLayout backgroundColor="Alice Blue" id="playbook-content">
      {chapters.map((chapter, index) => {
        let lastVisitedSection = progress[index].findIndex(section => section === 0);
        lastVisitedSection = lastVisitedSection < 0 ? 0 : lastVisitedSection;
        return (
          <Link
            to={`/${splashPageSlug}/${chapter.sections[lastVisitedSection].slug}`}
            id={`chapter${index + 1}`}
          >
            <ChapterCard
              id={index + 1}
              key={index}
              chapterNumber={index + 1}
              chapter={chapter}
              chapterProgress={progress[index]}
              splashPageSlug={splashPageSlug}
            />
          </Link>
        );
      })}
    </PlaybookHomeLayout>
  );
};

export default Chapters;
